module.exports = __webpack_public_path__ + "static/media/SYDummies25-4.1dbb4582.jpg";